import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { useState } from 'react';

export default function Footer() {
  const [subEmail, setSubEmail] = useState('');
  const [subStatus, setSubStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    const email = subEmail.trim();
    if (!email || !email.includes('@')) {
      setSubStatus('error');
      return;
    }
    setSubStatus('success');
    setSubEmail('');
    setTimeout(() => setSubStatus('idle'), 3000);
  };

  return (
    <footer className="bg-primary-500 text-background-50 rounded-t-3xl mt-16 md:mt-24">
      <div className="px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <h3 className="text-xl md:text-2xl font-heading font-light mb-4">
              订阅吃瓜快讯
            </h3>
            <p className="text-sm text-background-200 leading-relaxed mb-6">
              第一时间获取最新爆料资讯，每日精选热门吃瓜内容直送邮箱，绝不错过任何精彩瓜田。
            </p>
            <form onSubmit={handleSubscribe} className="flex flex-col gap-3">
              <input
                type="email"
                value={subEmail}
                onChange={(e) => { setSubEmail(e.target.value); setSubStatus('idle'); }}
                placeholder="输入您的邮箱地址"
                className="w-full bg-transparent border-b border-background-300/50 py-2 text-sm text-background-50 placeholder:text-background-400 focus:outline-none focus:border-accent-400"
              />
              <button
                type="submit"
                className="self-start bg-background-50 text-primary-500 px-5 py-2.5 rounded-full text-sm font-medium flex items-center gap-2 hover:bg-accent-100 transition-colors whitespace-nowrap"
              >
                立即订阅
                <i className="ri-arrow-right-line" />
              </button>
              {subStatus === 'success' && (
                <span className="text-xs text-accent-300">订阅成功！感谢您的关注</span>
              )}
              {subStatus === 'error' && (
                <span className="text-xs text-red-400">请输入有效的邮箱地址</span>
              )}
            </form>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-300 uppercase tracking-wider mb-4">
              快速导航
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-background-200 hover:text-accent-300 transition-colors underline underline-offset-4">
                  首页
                </Link>
              </li>
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-200 hover:text-accent-300 transition-colors underline underline-offset-4"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/about" className="text-sm text-background-200 hover:text-accent-300 transition-colors underline underline-offset-4">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-300 uppercase tracking-wider mb-4">
              联系我们
            </h4>
            <div className="space-y-2 text-sm text-background-200">
              <p>商务合作：hello@xjqkfyv.cn</p>
              <p>爆料投稿：hello@xjqkfyv.cn</p>
              <p className="pt-2">
                运营总部
                <br />
                中国 · 北京市朝阳区
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 md:mt-14 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4 text-sm">
            <span className="text-background-300 hover:text-accent-300 transition-colors cursor-pointer underline underline-offset-4">
              微博
            </span>
            <span className="text-background-300 hover:text-accent-300 transition-colors cursor-pointer underline underline-offset-4">
              微信公众号
            </span>
            <span className="text-background-300 hover:text-accent-300 transition-colors cursor-pointer underline underline-offset-4">
              抖音
            </span>
          </div>
          <p className="text-xs text-background-400 text-center">
            © 2026 五一吃瓜网 版权所有 | 吃瓜不打烊，爆料无止境
          </p>
          <div className="flex items-center gap-4 text-sm">
            <span className="text-background-300 hover:text-accent-300 transition-colors cursor-pointer underline underline-offset-4">
              隐私政策
            </span>
            <span className="text-background-300 hover:text-accent-300 transition-colors cursor-pointer underline underline-offset-4">
              免责声明
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}